import { Box, IconButton, InputAdornment, Menu, TextField, Typography } from '@mui/material';
import {
  orderByOptions,
  OrderByOptionsKeys,
  productKindDetails,
  SelectableProductKinds,
} from '@web/store/store-product-options';
import { SmartMenu } from '@web/common/components/navigation/smart-menu';
import { FC, useState } from 'react';
import styled from '@emotion/styled';
import SearchIcon from '@mui/icons-material/Search';
import SortIcon from '@mui/icons-material/Sort';
import CheckIcon from '@mui/icons-material/Check';

const OrderByMenu = styled(Menu)`
  li {
    min-width: 320px;
  }
`;

export interface StoreCoffeeSearchToolbarProps {
  smDown: boolean;
  selectedOrderByOption?: OrderByOptionsKeys;
  selectedKind: SelectableProductKinds;
  searchText: string;
  onSearchTextChange: (term: string) => void;
  onOrderByChange: (option: OrderByOptionsKeys) => void;
}

export const StoreCoffeeSearchToolbar: FC<StoreCoffeeSearchToolbarProps> = ({
  smDown,
  selectedOrderByOption,
  selectedKind,
  searchText,
  onSearchTextChange,
  onOrderByChange,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Box mb={2} mt={{ xs: 2, sm: 5 }}>
      {/* Mobile search field - full width above title */}
      {smDown && (
        <Box mb={2}>
          <TextField
            placeholder="Digite o produto desejado"
            fullWidth
            value={searchText}
            variant="outlined"
            size="small"
            onChange={e => {
              onSearchTextChange(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}
      {/* Title and actions row */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h4">
          Todos os {`${productKindDetails[selectedKind].label.toLowerCase()} `}
        </Typography>
        <Box display="flex" alignItems="center">
          {/* Desktop search field - inline with title */}
          {!smDown && (
            <TextField
              placeholder="Digite o produto desejado"
              fullWidth
              value={searchText}
              variant="outlined"
              size="small"
              onChange={e => {
                onSearchTextChange(e.target.value);
              }}
              // eslint-disable-next-line react/forbid-component-props
              style={{ width: '300px' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          )}
          <Box ml={smDown ? 0 : 2} display="inline-flex">
            <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
              <SortIcon />
            </IconButton>
          </Box>
          <OrderByMenu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            keepMounted
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            MenuListProps={{ disablePadding: true }}
          >
            <SmartMenu
              itemsOnly
              menuItems={[
                { label: 'Ordernar por', labelProps: { variant: 'subtitle1' } },
                ...(Object.keys(orderByOptions) as OrderByOptionsKeys[]).map(orderby => {
                  const active = selectedOrderByOption === orderby;
                  return {
                    label: orderByOptions[orderby],
                    onClick: () => {
                      setAnchorEl(null);
                      onOrderByChange(orderby);
                    },
                    active,
                    endIcon: { icon: active && <CheckIcon color="primary" fontSize="small" /> },
                  };
                }),
              ]}
            />
          </OrderByMenu>
        </Box>
      </Box>
    </Box>
  );
};
